export function convertLanguageToField(lingua, campo) {
  let value = campo + "Us";
  switch (lingua) {
    case "pt-BR":
      value = campo + "Br";
      break;
    case "pt-PT":
      value = campo + "Pt";
      break;
    case "es-ES":
      value = campo + "Es";
      break;
    case "de-DE":
      value = campo + "Al";
      break;
    case "it-IT":
      value = campo + "It";
      break;
    case "fr-FR":
      value = campo + "Fr";
      break;
    case "nl-NL":
      value = campo + "Nl";
      break;
    case "tr-TR":
      value = campo + "Tr";
      break;
    case "pl-PL":
      value = campo + "Pl";
      break;
    case "el-GR":
      value = campo + "Gr";
      break;
    case "hu-HU":
      value = campo + "Hu";
      break;
    case "id-ID":
      value = campo + "Id";
      break;
    case "ja-JP":
      value = campo + "Ja";
      break;
    case "cs-CZ":
      value = campo + "Cs";
      break;
    case "ro-RO":
      value = campo + "Ro";
      break;
    case "ru-RU":
      value = campo + "Ru";
      break;
    case "zh-Hans":
      value = campo + "Ch";
      break;
    case "en-US":
      value = campo + "Us";
      break;
    default:
      value = campo + "Us";
      break;
  }
  return value;
}

export function getVerdadeDesafioCategoryImage(id) {
  switch (id) {
    case 1:
      return require("../../assets/images/games/truthOrDareCategories/nuvem.png");

    case 2:
      return require("../../assets/images/games/truthOrDareCategories/fogo.png");

    case 3:
      return require("../../assets/images/games/truthOrDareCategories/boca.png");

    case 4:
      return require("../../assets/images/games/truthOrDareCategories/chicote.png");

    default:
      return require("../../assets/images/games/truthOrDareCategories/nuvem.png");
  }
}

export function formatTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  const minutesString = minutes < 10 ? `0${minutes}` : minutes.toString();
  const secondsString =
    remainingSeconds < 10
      ? `0${remainingSeconds}`
      : remainingSeconds.toString();

  return `${minutesString}:${secondsString}`;
}

export function getHoursBetweenDates(date1, date2) {
  const diffInMs = Math.abs(date2.getTime() - date1.getTime());
  return diffInMs / (1000 * 60 * 60);
}
